var map = {
	"./404.jpg": 90,
	"./about-hero.jpg": 483,
	"./features-02-image.png": 484,
	"./features-03-image-01.png": 155,
	"./features-03-image-02.png": 156,
	"./features-03-image-03.png": 157,
	"./features-avatar.jpg": 154,
	"./features-illustration.png": 153,
	"./hero-image-01.jpg": 485,
	"./hero-image-02.png": 158,
	"./icons/casa nera.png": 486,
	"./icons/headerlogo.png": 148,
	"./icons/homegym.png": 151,
	"./icons/homelogo.png": 149,
	"./icons/omino nero.png": 487,
	"./icons/penna nera.png": 488,
	"./icons/pt.png": 150,
	"./icons/rsblog.png": 152,
	"./news-01.jpg": 159,
	"./news-02.jpg": 160,
	"./news-03.jpg": 161,
	"./news-04.jpg": 489,
	"./news-05.jpg": 490,
	"./news-06.jpg": 491,
	"./news-07.jpg": 492,
	"./news-08.jpg": 493,
	"./news-09.jpg": 494,
	"./news-10.jpg": 162,
	"./news-11.jpg": 163,
	"./news-12.jpg": 164,
	"./news-author-01.jpg": 91,
	"./news-author-02.jpg": 165,
	"./news-author-03.jpg": 166,
	"./news-author-04.jpg": 65,
	"./news-author-05.jpg": 495,
	"./news-author-06.jpg": 496,
	"./news-inner-image.jpg": 497,
	"./news-single.jpg": 498,
	"./tabs-image-01.jpg": 499,
	"./team-member-01.jpg": 167,
	"./team-member-02.jpg": 168,
	"./team-member-03.jpg": 169,
	"./team-member-04.jpg": 170,
	"./team-member-05.jpg": 171,
	"./team-member-06.jpg": 172,
	"./team-member-07.jpg": 173,
	"./team-member-08.jpg": 174,
	"./team-mosaic-01.jpg": 175,
	"./team-mosaic-02.jpg": 176,
	"./team-mosaic-03.jpg": 177,
	"./team-mosaic-04.jpg": 178,
	"./testimonial-01.jpg": 500,
	"./testimonial-02.jpg": 501,
	"./testimonial-03.jpg": 502,
	"./world-user-01.jpg": 503,
	"./world-user-02.jpg": 504,
	"./world-user-03.jpg": 505,
	"./world-user-04.jpg": 506,
	"./world-user-05.jpg": 507,
	"./world-user-06.jpg": 508,
	"./world-user-07.jpg": 509,
	"./world-user-08.jpg": 510,
	"./worldmap.png": 511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 482;